module.exports = __webpack_public_path__ + "img/logo.70e0f331.png";